import EarlyYearsFoundationSVG from "../../../../src/content/school-years/svg/early-years-foundaion-stage.svg";
import * as React from 'react';
export default {
  EarlyYearsFoundationSVG,
  React
};